import { type CustomThemeConfig, useGetTheme } from '@pba/react-theme';
import { isOneOf } from '@pba/react-utils';
import { useCallback } from 'react';

const spacingKeys: Array<keyof CustomThemeConfig['spacing']> = [
  'lg',
  'md',
  'ms',
  'sm',
  'xl',
  'xs',
  'xxl',
  'xxs',
  'xxxs',
];

type SpacingKey = keyof CustomThemeConfig['spacing'];

export const useResolveSpacingValue = () => {
  const { spacing } = useGetTheme();

  return useCallback(
    <T>({ value }: { value: SpacingKey | T }): number | T => {
      if (typeof value === 'string' && isOneOf(value, spacingKeys)) {
        return spacing[value].value;
      }

      return value;
    },
    [spacing],
  );
};
